import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { scribeDocumentBase } from 'apps/scribe/ScribePropTypes';
import FreeHtmlBanner from 'apps/scribe/containers/FreeHtmlBanner';

class SubscriptionsInfoBannerContainer extends PureComponent {
  static propTypes = {
    landingPage: PropTypes.shape({
      ...scribeDocumentBase,
      infoBanner: PropTypes.shape({
        ...scribeDocumentBase,
        html: PropTypes.string.isRequired,
        showOnMobile: PropTypes.bool,
      }),
    }),
    routeString: PropTypes.string.isRequired,
  };

  render() {
    const { landingPage } = this.props;

    if (!(landingPage && landingPage.infoBanner)) {
      return null;
    }

    const { landingPage: { infoBanner, infoBanner: { showOnMobile } } } = this.props;

    return (
      <FreeHtmlBanner
        {...infoBanner}
        parentContainer={landingPage}
        showOnMobile={showOnMobile}
        updatable
      />
    );
  }
}

export default connect(
  (state, ownProps) => ({
    landingPage: get(state, `catalogue.productsPagesByRoute['${ownProps.routeString}'].scribeContent.landingPage`),
  })
)(SubscriptionsInfoBannerContainer);
